import { c as _c } from "react/compiler-runtime";
import { CouponEntity } from '../../../../domain/entry.js';
import { useEngine } from '../../engine/hooks/useEngine.js';
import { useSubscribedCouponCollection } from './useSubscribedCouponCollection.js';
/**
 * Calculates price of given coupon for all coupon indices, sportkryss included.
 *
 * @param root0 Hook arguments
 * @param root0.couponId Unique id of the coupon
 * @returns Total coupon price
 */
export function useCouponsPrice(t0) {
  const $ = _c(5);
  const {
    couponId
  } = t0;
  const definition = useEngine();
  let t1;
  if ($[0] !== definition) {
    t1 = collection => {
      if (!collection || collection.length === 0) {
        return 0;
      }
      return collection.reduce((total, coupon) => total + CouponEntity.getPrice(coupon, {
        definition: definition.model
      }), 0);
    };
    $[0] = definition;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== couponId || $[3] !== t1) {
    t2 = {
      couponId,
      selector: t1
    };
    $[2] = couponId;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const totalPrice = useSubscribedCouponCollection(t2);
  return totalPrice;
}